import React from "react";
import { useParams } from "react-router-dom";
import EmployeeCard from "./../../Components/EmployeeCard/EmployeeCard";
import {
  useGetActiveEmployeeDetailsByEmployeeIdQuery,
  useGetProfilePictureByEmployeeIdQuery,
} from "../../API Services/GraphAPIs/employeeDetailsGraphAPIs";
import { useGetCompanyDetailsQuery } from "../../API Services/GraphAPIs/companyDetailsAPIs";
import { useGetActiveLocationsQuery } from "../../API Services/GraphAPIs/locationAPIs";
import { CircularProgress, Box } from "@mui/material";

const Home = () => {
  const { employeeCode } = useParams<{ employeeCode: string }>();

  const {
    isLoading: activeEmployeeDetailsByEmployeeIdLoading,
  } = useGetActiveEmployeeDetailsByEmployeeIdQuery(
    { employeeId: employeeCode ?? "" },
    { skip: !employeeCode }
  );

  const {
    isLoading: loadingEmployeeProfilePictures,
  } = useGetProfilePictureByEmployeeIdQuery(
    { employeeId: employeeCode ?? "" },
    { skip: !employeeCode }
  );

  const {
    isLoading: loadingCompanyDetails,
  } = useGetCompanyDetailsQuery({});

  const {
    isLoading: loadingActiveLocations,
  } = useGetActiveLocationsQuery({});

  const isEverythingLoaded =
    !activeEmployeeDetailsByEmployeeIdLoading &&
    !loadingEmployeeProfilePictures &&
    !loadingActiveLocations &&
    !loadingCompanyDetails;

  return (
    <div>
      {!isEverythingLoaded ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress sx={{ color: "gray", width: "30px", height: "30px" }} />
        </Box>
      ) : (
        <EmployeeCard employeeCode={employeeCode} />
      )}
    </div>
  );
};

export default Home;
